import React from "react";
import IndividualizationOverview from "../compositions/Individualization/Overview";
import {IndividualizationContextProvider} from "../contexts/individualizationContext";
import DuplicateIndividualization from "../compositions/Individualization/DuplicateIndividualization";
import EditIndividualization from "../compositions/Individualization/EditIndividualization";
import CreateIndividualization from "../compositions/Individualization/CreateIndividualization";

const Individualization: React.FC = () => {
    return (
        <IndividualizationContextProvider>
            <IndividualizationOverview/>
            <CreateIndividualization/>
            <EditIndividualization/>
            <DuplicateIndividualization/>
        </IndividualizationContextProvider>
    );
};

export default Individualization;
